<template>
  <div class="vr360-tabs">
    <template v-if="state === 'publicList'">
      <ul class="vr360-tabs__list">
        <li class="vr360-tabs__list__item">
          <button type="button" class="vr360-tabs__tab" :class="{ 'selected-tab' : filter === 'all' }" @click="selectFilter('all')">
            <span class="vr360-head-h4 vr360-text-gray-2">All streams</span>
          </button>
        </li>
        <li class="vr360-tabs__list__item">
          <button type="button" class="vr360-tabs__tab" :class="{ 'selected-tab' : filter === 'live' }" @click="selectFilter('live')">
            <span class="vr360-head-h4 vr360-text-gray-2">Live now</span>
          </button>
        </li>
        <li class="vr360-tabs__list__item">
          <button type="button" class="vr360-tabs__tab" :class="{ 'selected-tab' : filter === 'popular' }" @click="selectFilter('popular')">
            <span class="vr360-head-h4 vr360-text-gray-2">Popular</span>
          </button>
        </li>
      </ul>
    </template>
    <template v-if="state === 'myList'">
      <ul class="vr360-tabs__list">
        <li class="vr360-tabs__list__item">
          <button type="button" class="vr360-tabs__tab" :class="{ 'selected-tab' : filter === 'all' }" @click="selectFilter('all')">
            <span class="vr360-head-h4 vr360-text-gray-2">My streams</span>
          </button>
        </li>
        <li class="vr360-tabs__list__item">
          <button type="button" class="vr360-tabs__tab" :class="{ 'selected-tab' : filter === 'history' }" @click="selectFilter('history')">
            <span class="vr360-head-h4 vr360-text-gray-2">History</span>
          </button>
        </li>
        <li class="vr360-tabs__list__item">
          <button type="button" class="vr360-tabs__tab" :class="{ 'selected-tab' : filter === 'likes' }" @click="selectFilter('likes')">
            <span class="vr360-head-h4 vr360-text-gray-2">Likes</span>
          </button>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import setts from "@/config/setts";

export default {
  name: "tabsHeader",
  data() {
    return {
      state: null
    };
  },
  created() {
    this.checkToShow(this.$route.name);
  },
  methods: {
    checkToShow(name) {
      switch (name) {
        case "ListMyStreams":
          this.state = "myList";
          break;
        case "ListPublicStreams":
          this.state = "publicList";
          break;
        default: 
          this.state = null;
          break;
      }
    },
    selectFilter(filter) {
      const updatedQuery = { ...this.$route.query, ...{ filter }}
      this.$router.push({ query: updatedQuery });
    }
  },
  watch: {
    $route(to) {
      this.checkToShow(to.name);
    }
  },
  computed: {
    ...mapGetters({
      filter: "stream/streamsListFilter",
    })
  }
};
</script>

<style lang="scss">
</style>
